module.exports = __webpack_public_path__ + "img/ico-drops.28897c9e.png";